import { connect } from 'react-redux';
import SummaryCard from '../../../components/home/SummaryCard';
import {
  loadingStores,
  currentStore,
  loadingProgress,
  totalProgressBaseline,
  pendingProgressBaseline,
} from 'core/selectors';

export default connect(
  state => ({
    loading: loadingStores(state) || !currentStore(state) || loadingProgress(state),
    total: totalProgressBaseline(state),
    pending: pendingProgressBaseline(state),
  }),
  {},
)(SummaryCard);
